<div class="pedido-nao-liberado-card-info-descontos-maximos-itens-excedidos card card-warning">
    <div class="card-header">
        <p class="card-title mb-0">
            <i class="fas fa-exclamation-triangle"></i> Itens com descontos acima do limite permitido
        </p>
    </div>

    <ul class="list-group list-group-flush list-group-vertical">
        <li class="list-group-item">
            <span class="list-group-item-title">
                Motivo da Não Liberação
            </span>
            <span class="list-group-item-value">
                Este {{tipoVenda | pedidoTipoVendaSinonimo}} não foi liberado por que possui itens com descontos acima do limite permitido
            </span>            
        </li>
        <li class="list-group-item">
            <span class="list-group-item-title">
                Não Liberado em
            </span>
            <span class="list-group-item-value">
                {{dataNaoLiberado | date: 'dd/MM/yyyy'}} às {{dataNaoLiberado | date: 'HH:mm'}}
            </span>            
        </li>        
    </ul>

    <pedido-item-desconto-maximo-excedido-table-view
        #tableView
        idTable="tablePedidoItensDescontosMaximosExcedidos_card_nao_liberado">
    </pedido-item-desconto-maximo-excedido-table-view>
</div>